import React, { useState } from "react";
import ExtensionCard from "app/popleads/components/ui-kit/ExtensionCard";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import { POPUP_CONTENTS } from "../utils/constants";
import { useExtensionContext } from "../ExtensionContext";
import { StyledCardContent } from "./common/styled";
import ExtensionCampaignSearchInput from "./ExtensionCampaignSearchInput";
import { toast } from "react-toastify";
import useEtiketEkle from "app/popleads/hooks/useEtiketEkle";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { colors } from "app/popleads/components/ui-kit/colors";
export const StyledCampaignLinkContent = styled(StyledCardContent)`
    color: ${(props) => colors.l3rnTech[900]};
    &:hover {
        text-decoration: underline;
    }
`;
const ExtensionCourseCard = () => {
    const {
        profile,
        setState,
        popit,
        collapsedCards,
        setCollapsedCard,
        etiketListLoading,
        courseRef,
    } = useExtensionContext();
    const [showSearchCampaign, setShowSearchCampaign] = useState(false);
    const collapsed = collapsedCards.course;
    const handleCollapseChange = (val) => {
        setCollapsedCard("course", val);
    };

    const { etiketEkle } = useEtiketEkle();
    const user = useSelector((state) => state.auth.user);

    const etiketList = profile?.etiket?.map((etiket) => {
        return {
            content: (
                <a
                    href={user?.company?.companyConfig?.oldCrmPopleadsHttpLink + "/?campaignId=" + etiket?.campaignId}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <StyledCampaignLinkContent>{etiket.metin}</StyledCampaignLinkContent>
                </a>
            ),
        };
    });

    const handleButtonClick = () => {
        if (showSearchCampaign) {
            setShowSearchCampaign(false);
        } else {
            if (popit) {
                toast.warning("You need to POP the profile first.");
            } else {
                setShowSearchCampaign(true);
                collapsedCards.course === true && setCollapsedCard("course", false);
            }
        }
    };

    return (
        <div ref={courseRef} style={{ padding: "12px 0px", borderBottom: "1px solid rgb(225, 225, 225)" }}>
            <ExtensionCard
                isLoading={etiketListLoading}
                iconWidth="0px"
                homePage={true}
                collapsed={collapsed}
                onCollapseChange={handleCollapseChange}
                input={
                    <ExtensionCampaignSearchInput
                        label={false}
                        optionClick={(value) => {
                            etiketEkle({ profil: profile.id, etiket: value?.id });
                        }}
                    />
                }
                isShowInput={showSearchCampaign}
                button={
                    <ButtonWithText
                        icon={showSearchCampaign ? "remove" : "add"}
                        iconType="material"
                        variant="l3rnTech"
                        buttonStyle="default"
                        size="circle"
                        onClick={handleButtonClick}
                    />
                }
                cardTitle={profile?.etiket?.length > 0 ? `Campaigns (${profile?.etiket?.length})` : "Campaigns"}
                cardTitleOnClick={() => {
                    if (popit) {
                        toast.warning("You need to POP the profile first.");
                    } else {
                        setState({ popupContent: POPUP_CONTENTS.COURSES, popupIsOpen: true });
                    }
                }}
                cardItems={etiketList}
                viewMoreOnClick={() => {
                    setState({ popupContent: POPUP_CONTENTS.COURSES, popupIsOpen: true });
                }}
                minVisibleItems={0}
                errorDescription="Click the + to assign a campaign."
            />
        </div>
    );
};

export default ExtensionCourseCard;
